import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function DVWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1070">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1071">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1072">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-1073">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1074">
              <img src="https://cdn.magicpatterns.com/uploads/7sGKWERWU55sNzJp8h5fbD/vaginal-rejuv.jpg" alt="Feminine Wellness at Be CLINICAL" className="w-full h-full object-cover" data-id="element-1075" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-1076">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1077">
              WHY CHOOSE BE CLINICAL FOR VAGINAL REJUVENATION
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1078"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1079">
              <p data-id="element-1080">
                At Be CLINICAL, vaginal rejuvenation aligns with our commitment
                to holistic well-being and personalized care. We prioritize your
                intimate wellness journey, employing advanced technologies like
                the diVa Vaginal Laser Treatment to address your concerns with
                safety and effectiveness. With a focus on discretion, comfort,
                and empowerment, Be CLINICAL ensures that you receive
                comprehensive support tailored to your unique needs, promoting
                your overall health and confidence.
              </p>
              <p data-id="element-1081">
                Schedule your complimentary consultation today and discover how
                we can help you restore pleasure and confidence.
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1082">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}